import { useMemo } from 'react';

import { useSubjectDocumentsListQuery } from '@/services/api/documentSubjectService';

export const useIntakeRetainer = ({
  intakeId,
}: {
  intakeId: string | null;
}) => {
  const {
    data: intakeDocuments,
    isLoading: isIntakeDocumentsLoading,
    refetch: refetchIntakeDocuments,
  } = useSubjectDocumentsListQuery(
    {
      subjectId: intakeId!,
      subjectType: 'intake',
    },
    { skip: !intakeId },
  );

  const engagementLetters = useMemo(() => {
    return intakeDocuments?.filter(
      (document) =>
        document.document_template?.category === 'RETAINER',
    );
  }, [intakeDocuments]);

  const latestEngagementLetter = useMemo(() => {
    return engagementLetters?.[0];
  }, [engagementLetters]);

  return {
    engagementLetters,
    latestEngagementLetter,
    isIntakeDocumentsLoading,
    refetchIntakeDocuments,
  };
};
